import { render } from "./Cooperation.vue?vue&type=template&id=bd60309e"
import script from "./Cooperation.vue?vue&type=script&lang=js"
export * from "./Cooperation.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__